import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  tableOverflow: {
    overflow: 'auto'
  }
}));
